/**
 * @enum {string} DeveloperAvatarBgColor
 * @description 开发者头像背景颜色的枚举
 */
export enum DeveloperAvatarBgColor {
  /** 蓝色 */
  Blue = 'rgba(0, 117, 255, 0.8)',
  /** 绿色 */
  Green = 'rgba(0, 181, 81, 0.8)',
  /** 橙色 */
  Orange = 'rgba(255, 122, 0, 0.8)',
  /** 红色 */
  Red = 'rgba(255, 45, 47, 0.8)',
  /** 粉红色*/
  Pink = 'rgba(255, 40, 147, 1)',
  /** 紫色 */
  Purple = 'rgba(142, 142, 254, 1)'
}

/**
 * @enum {number} VerifyInfoStatusConst
 * 发送验证码时判断是否需要人机验证的枚举 1：需要，-1：不需要
 */
export const enum VerifyInfoStatusConst {
  /** 需要人机验证 */
  Distrust = 1,
  /** 不需要人机验证 */
  trust = -1
}

/**
 * @enum {number} IsSubAccountConst
 * @description 是否是子账号的常量枚举
 */
export const enum IsSubAccountConst {
  /** 是子账号 */
  True = 1,
  /** 不是子账号 */
  False = -1
}

/**
 * @enum {number} Errorno
 * @description 登录状态码
 */
export const enum Errorno {
  NotLogin = -6
}

/**
 * @enum {number} ValidateNumConst
 * @description 人机验证结果的常量枚举
 */
export const enum ValidateResultConst {
  /** 还没通过 */
  NotPass = 1,
  /** 已经通过 */
  Pass = 2
}

/**
 * @enum {number} AccountPowerConst
 * @description 账号权限的常量枚举
 */
export const enum AccountPowerConst {
  /** 游戏管理 */
  GameManagement = 1,
  /** 手游数据统计 */
  MobileGameDataStatistics = 2,
  /** H5数据统计 */
  H5DataStatistics = 3,
  /** 结算中心 */
  SettlementCenter = 4
}

/**
 * @enum {number} comLoginRegisterDialogModeConst
 * @description 国内版和国际版共用的登录注册弹窗模式的常量枚举
 */
export const enum LoginRegisterDialogModeConst {
  /**
   * @description 国内版：手机邮箱账号登录
   * @description 国际版：邮箱账号登录
   */
  AccountLogin = 1,
  /**
   * @description 国内版：手机短信验证码登录
   * @description 国际版：邮箱验证码登录
   */
  SmsOrEmailLogin = 2,
  /** 账号注册 */
  AccountRegister = 3,
  /** 重置密码 */
  ResetPassword = 4,
  /** 账号申诉 */
  AccountAppeal = 5,
  /**
   * 验证邮箱
   * @description 只在国际版会出现
   */
  VerifyEmail = 6
}
